<!-- Goodsreview.vue -->
<template>
  <div id="review" ref="review" class="ui-review-wrapper ui-detail-common" @click="getGoodsEvaluation()">
    <div class="main-content"><flex-line :is-link="true" :show-border="true"><span class="line-name">{{ $t('Comment') }}</span></flex-line>
    </div>
    <div class="goods-review-body">
      <review-list :list="reviewList"></review-list>
    </div>
  </div>
</template>

<script>
import ReviewList from './ReviewList'
import flexLine from '../../../flexLine'
import { getReviewList } from '../../../../api/homegoodsdetail'
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      reviewList: []
    }
  },

  computed: {
    ...mapState({
      currentProductId: state => state.goodsdetail.currentProductId
    })
  },

  components: {
    flexLine,
    ReviewList
  },

  created() {
    this.getReviewList()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {

    getReviewList() {
      getReviewList(this.currentProductId, '', 1).then(res => {
        if (res) {
          this.reviewList = res.result.goods_eval_list
        }
      })
    },

    /* 评论 */
    getGoodsEvaluation() {
      this.$router.push({ name: 'HomeGoodsEvaluation', query: { goods_id: this.currentProductId } })
    },
    handleScroll() {
      let reviewtop = this.$refs.review.getBoundingClientRect().top;
      this.$emit('reviewtop', reviewtop);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
}
</script>

<style lang="scss" scoped>
.main-content {
  padding: 0 $pageSpace;
  background-color: #fff;
}

.ui-review-wrapper {
  .goods-review-body {
    background: #ffffff;
  }
}
</style>
